"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.colors = void 0;
var none = 'rgba(0,0,0,0)';
var primaryColor100 = '#33A4FF';
var primaryColor40 = '#addbff';
var primaryColor10 = '#ebf6ff';
var primaryColorText = '#0071CC';
var white = '#fff';
var white_opacity50 = 'rgba(255, 255, 255, 0.5)';
var white_opacity80 = 'rgba(255, 255, 255, 0.8)';
var white_opacity60 = 'rgba(255, 255, 255, 0.6)';
var red = '#e60000';
var lightRed = '#FCE6E6';
var invertRed = '#FF9999';
var hoverRed = '#B70000'; // rarely used, TagLink comp
var hoverInvertRed = '#FBC3C3'; // rarely used, TagLink comp
var yellow = '#FFCC00';
var lightYellow = '#FFFAE6';
var green = '#08A84B';
var lightGreen = '#E6F6ED';
var invertGreen = '#8AE5B0';
var hoverGreen = '#00953F'; //  rarely used, TagLink comp
var invertHoverGreen = '#BDF4D4'; // rarely used, TagLink comp
var cyan = '#B5F2FA';
var lightPink = '#FFE5F2';
var blue = '#33A4FF';
var lightBlue = '#EBF6FF';
var black = '#000';
var black_opacity80 = 'rgba(0, 0, 0, 0.8)';
var black_opacity30 = 'rgba(0, 0, 0, 0.3)';
var black_opacity05 = 'rgba(0, 0, 0, 0.05)';
var black_opacity50 = 'rgba(0, 0, 0, 0.5)';
var greyColor100 = '#383838';
var greyColor90 = '#4c4c4c';
var greyColor80 = '#606060';
var greyColor70 = '#747474';
var greyColor50 = '#9B9B9B';
var greyColor40 = '#afafaf';
var greyColor15 = '#e1e1e1';
var greyColor10 = '#EBEBEB';
var greyColor5 = '#f5f5f5';
var greyColor3 = '#f9f9f9';
var greyColor100_opacity70 = ' rgba(56, 56, 56, 0.7)';
var lightShadowColor = '#33A4FF';
var darkShadowColor = white;
var disabledShadowColor = greyColor70;
// Highlight colors used in RTE 
var pinkHighlight = '#FF9AF4';
var blueHighlight = '#52E2EE';
var yellowHighlight = "#FFE600";
// annotation RTE Colors
var annoPink = '#FF91F4';
var annoBlue = '#52E2EE';
exports.colors = {
    none: none,
    white: white,
    white_opacity50: white_opacity50,
    white_opacity80: white_opacity80,
    white_opacity60: white_opacity60,
    red: red,
    lightRed: lightRed,
    invertRed: invertRed,
    hoverRed: hoverRed,
    hoverInvertRed: hoverInvertRed,
    yellow: yellow,
    lightYellow: lightYellow,
    green: green,
    lightGreen: lightGreen,
    invertGreen: invertGreen,
    hoverGreen: hoverGreen,
    invertHoverGreen: invertHoverGreen,
    blue: blue,
    lightBlue: lightBlue,
    black: black,
    black_opacity05: black_opacity05,
    black_opacity30: black_opacity30,
    black_opacity50: black_opacity50,
    black_opacity80: black_opacity80,
    greyColor100: greyColor100,
    greyColor90: greyColor90,
    greyColor80: greyColor80,
    greyColor70: greyColor70,
    greyColor40: greyColor40,
    greyColor50: greyColor50,
    greyColor15: greyColor15,
    greyColor10: greyColor10,
    greyColor5: greyColor5,
    greyColor3: greyColor3,
    greyColor100_opacity70: greyColor100_opacity70,
    lightShadowColor: lightShadowColor,
    darkShadowColor: darkShadowColor,
    disabledShadowColor: disabledShadowColor,
    primaryColor10: primaryColor10,
    primaryColor100: primaryColor100,
    primaryColor40: primaryColor40,
    primaryColorText: primaryColorText,
    cyan: cyan,
    lightPink: lightPink,
    pinkHighlight: pinkHighlight,
    blueHighlight: blueHighlight,
    yellowHighlight: yellowHighlight,
    annoPink: annoPink,
    annoBlue: annoBlue,
};
